import script from "./DetailSupplierModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailSupplierModal.vue?vue&type=script&setup=true&lang=js"

import "./DetailSupplierModal.vue?vue&type=style&index=0&id=c32d0ca2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c32d0ca2"]])

export default __exports__